<template>
  <AuthForm />
</template>
<script setup lang="ts">
  useHead({ title: 'Reset Password | Yogen' })
</script>
